import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import { useChainId, useSwitchChain } from "wagmi";
import { BLOCKCHAINS, TEST_BLOCKCHAINS } from "@/constants/chain-details";
import { useParams } from "next/navigation";
import Link from "next/link";
import { isMainnet } from "@/constants/flags.constant";

const ChainEnvSwitch = () => {
  const { network } = useParams() as { network: string };
  const { switchChainAsync } = useSwitchChain();

  const chainId = useChainId();

  const handleSwitch = async (switchStatus: boolean) => {
    //? Do nothing if the same switch status is selected
    if (network === "mainnet") return;

    //? Get the current chain env and its opposite
    const chains = network === "mainnet" ? BLOCKCHAINS : TEST_BLOCKCHAINS;
    const oppositeChains =
      network === "mainnet" ? TEST_BLOCKCHAINS : BLOCKCHAINS;

    const currentChain = chains.find((chain) => chain.chainId === chainId);
    const oppositeEnvChain = oppositeChains.find(
      (chain) => chain.ticker === currentChain?.ticker,
    );

    if (oppositeEnvChain) {
      await switchChainAsync({
        chainId: oppositeEnvChain.chainId,
      });
    }
  };

  return (
    <div className={styles.switchContainer}>
      <Link href={""}>
        <button
          className={classNames(!isMainnet && styles.active)}
          onClick={() => handleSwitch(false)}
        >
          TESTNET
        </button>
      </Link>
      <button
        className={classNames(isMainnet && styles.active)}
        onClick={() => handleSwitch(true)}
      >
        MAINNET
      </button>
    </div>
  );
};

export default ChainEnvSwitch;
